import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import Select from "react-select";
import axios from "axios";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const AddState = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [countryDrp, setCountryDrpData] = useState([]);

  const [formdata, setFormData] = useState({
    id: null,
    name: "",
    state_code: "",
    country_id: "",
  });

  const getCountryDrpData = () => {
    axios.post(API_URL.COUNTRY_LIST, {}).then((res) => {
      setCountryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCountryDrpData(cd);
    });
  };
  const onSave = () => {
    if (formdata.name && formdata.country_id && formdata.state_code) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.STATE_UPDATE : API_URL.STATE_SAVE;
      axios.post(pUrl, formdata).then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "State Updated Successfully."
            : "State Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          setLoading(false);
          navigate("/state");
        }
      })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };


  const onEdit = () => {
    axios.post(API_URL.STATE_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          state_code: res.data.data.state_code ? res.data.data.state_code : "",
          country_id: res.data.data.country_id ? res.data.data.country_id : "",
        });
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formdata[key];
  };


  useEffect(() => {
    getCountryDrpData();
  }, []);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} State</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/state"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="name"
                        value={formdata.name}
                        className={
                          isRequiredField("name")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="name"
                        onChange={(event) => {
                          setFormData({ ...formdata, name: event.target.value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>State Code<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="state_code"
                        value={formdata.state_code}
                        className={
                          isRequiredField("state_code")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="state_code"
                        onChange={(event) => {
                          setFormData({ ...formdata, state_code: event.target.value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label htmlFor="Country">Country<span className="required-star">*</span></label>
                      <Select
                        options={countryDrp}
                        value={countryDrp.find(
                          (r) => r.value == formdata.country_id
                        )}
                        styles={
                          isRequiredField("country_id")
                            ? customRequireStyles
                            : customStyles
                        }
                        onChange={(e) =>
                          setFormData({ ...formdata, country_id: e.value })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddState;
